import { GameLoop } from './GameLoop';

let id = 0;

export abstract class Entity {
  id: number;
  loop?: GameLoop;
  static type: string;

  constructor() {
    this.id = id++;
  }

  connect(loop: GameLoop) {
    this.loop = loop;
  }

  step(_: number) {}

  destroy() {}
}
